module.exports = Studio;


/*****************
 ** WEBPACK FOOTER
 ** external "Studio"
 ** module id = 1
 ** module chunks = 0
 **/